import { API_URL } from "env";

interface DashboardUserResponse {
    status: boolean;
    data: {
        revenue: number;
        total_products: number;
        total_orders: number;
        total_wishlist_products?: number;
        total_viewed_products?: number;
    };
    msg: string;
}

async function getDashboardUser() : Promise<DashboardUserResponse> {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No token found');
    }
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/dashboard/order_revenue`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch dashboard user data');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching dashboard user data:', error);
        throw error;
    }
}

export { getDashboardUser };